import { render, staticRenderFns } from "./choosePlan.vue?vue&type=template&id=19508218&scoped=true"
import script from "./choosePlan.vue?vue&type=script&lang=js"
export * from "./choosePlan.vue?vue&type=script&lang=js"
import style0 from "./choosePlan.vue?vue&type=style&index=0&id=19508218&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19508218",
  null
  
)

export default component.exports